import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import FranchiseeIcon from '@/svg-icons/franchisee';

function FranchiseeSection({ franchisees }) {
  if (!franchisees) return null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <FranchiseeIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="franchisee" />
      </div>

      <div className="text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]" data-cy="order-details-franchisee">
        {franchisees.franchisee}
      </div>
    </div>
  );
}

FranchiseeSection.propTypes = {
  franchisees: PropTypes.object.isRequired,
};

export default FranchiseeSection;
